const VERSION = '2.0.23p'
export default VERSION
